import { Component } from '@angular/core';
import { thisYear } from 'elbuild-ui-lib-core';
import { environment } from 'src/environments/environment';
import { VERSION } from 'src/environments/version';

@Component({
	selector: 'app-footer',
	standalone: false,
	templateUrl: './footer.component.html',
	styleUrl: './footer.component.scss'
})
export class FooterComponent {


	currentyear = thisYear();
	topbartext = environment.topbartext;
	copyright = environment.copyright;

	version = VERSION;

	env = environment;


}
